export default "__VITE_ASSET__BlSoTySw__"